module.exports = __webpack_public_path__ + "static/media/linkedinlogo.68c857f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/linkedinlogo.png
// module id = 41
// module chunks = 0